// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RuleList_wrapper__3B_cL"};